import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment  from 'moment';
import { Loading } from '../../components/Loading';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import { UserBookInfo } from '../common/UserBookInfo';
import { scrollToElement } from '../../../lib/userFunctions';
import { AlertMessage } from 'app/components/AlertMessage';
import { useQuery, useMutation } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { getEpisode } from '../apiUserBook';
import { LikeButton } from 'app/components/LikeButton';
import { CommentList } from 'app/comment/CommentList';
import sanitizeHtml from 'sanitize-html';
import { sanitizeOption } from 'lib/sanitizeHtml';

export const UserBookEpisodeView = ()=>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { school, episode } = useParams();
    const auth = useSelector(state => state.auth);
    useEffect(() =>scrollToElement('userbook_subpage'), [dispatch, episode]);

    const { data:userBookEpisode, isLoading, isError, error, isSuccess } = useQuery({
        queryKey:['userbook/episode', episode],
        queryFn:getEpisode
    });
    

    const  gotoEpisode = (id)=>{
        navigate(`/${school}/userbook/episode/view/${id}${location.search}`);
    }

    const onChangeEpisode = (event)=>{
        const target = event.target
        if( target.value!==episode ){
            gotoEpisode(target.value);
        }
    }

    
    const deleteMutate = useMutation({
        mutationFn:(id)=>Api.get(`/api/userBook/episode/${id}/delete/force`),
        onSuccess:(res)=>{
            navigate(`/${school}/userbook/view/${userBookEpisode?.data?.bookId}${location.search}`);
        },
        onError:(err)=>{
            toast.error( createFetchErrorMessage(err).message );
        }
    })

    const onDelete = ()=>{
        if( deleteMutate.isPending ) return;
        if(!window.confirm("삭제하시겠습니까?"))return;
        deleteMutate.mutate(episode);
    }

    function renderEpisodeList(){
        return userBookEpisode?.data?.list.map((episode, key)=>{
            return <option key={key} value={episode.id}>{episode.episodeNum} 번째 글 </option>
        });
        
    }


    if (isError){
        return <ErrorMessageBox message={createFetchErrorMessage(error).message}
                                        goto={<Link className="btn _border" to={`/${school}/userbook${location.search}`} >목록</Link>} />;
    }

    
    return (
        <div className="userBookEpisodeView">
            <UserBookInfo bookId={userBookEpisode?.data?.bookId} />
            <div className="inner">
                <div className={`${userBookEpisode?.data?.episode.deleteYn === "Y" ? "deleteContainer" : ""}`}>
                    <AlertMessage type="delete" text="삭제됨" visible={userBookEpisode?.data?.episode.deleteYn === "Y"} />
                    <div className="episodeContainer">
                        <div className="header">
                            <h2 className="title">
                                {userBookEpisode?.data?.episode.subject}
                            </h2>
                            <div className="info">
                                {userBookEpisode?.data?.episode.createdAt && moment(userBookEpisode?.data?.episode.createdAt).format('LLL')}
                                <span className="hitsCount">조회수 <strong>{userBookEpisode?.data?.episode.readCount}</strong></span>
                            </div>
                        </div>
                        { isLoading && <Loading /> }
                        <div className="content editor_view" dangerouslySetInnerHTML={{__html:sanitizeHtml(userBookEpisode?.data?.episode.content, sanitizeOption)}}></div>
                        
                        { userBookEpisode?.data?.list.length>1 &&
                        <div className="episodeNavigation">
                            { userBookEpisode?.data?.prevEpisode!==null &&
                                <div className="buttonBox pre">
                                    <button className="btn _turq" onClick={()=>{gotoEpisode(userBookEpisode?.data?.prevEpisode.id)}}><i className="fas fa-light fa-angle-left"></i></button>
                                    <div className="page_info pre_info">
                                        <p>이전화</p>
                                        <p className="title">{userBookEpisode?.data?.prevEpisode.subject}</p>
                                    </div>
                                </div>
                            }
                            { userBookEpisode?.data?.nextEpisode!==null &&
                                <div className="buttonBox next">
                                    <button className="btn _turq" onClick={()=>{gotoEpisode(userBookEpisode?.data?.nextEpisode.id)}}><i className="fas fa-light fa-angle-right"></i></button>
                                    <div className="page_info next_info">
                                        <p>다음화</p>
                                        <p className="title">{userBookEpisode?.data?.nextEpisode.subject}</p>
                                    </div>
                                </div>
                            }
                        </div>
                        }
                    </div>

                    <div className="controls">
                        <LikeButton activity={userBookEpisode?.data?.episode} type="userbookEpisode" />
                        
                        <Link className="btn _sm light_gray right" to={`/${school}/userbook/view/${userBookEpisode?.data?.bookId}`}>목록</Link>
                        { userBookEpisode?.data?.list.length>0 &&
                            <div className="episode_box right">
                                <select className="episode" value={episode} onChange={onChangeEpisode}>
                                    {renderEpisodeList()}
                                </select>
                            </div>
                        }
                    </div>
                    { userBookEpisode?.data?.episode.userId===auth.id && 
                        !userBookEpisode?.data?.completed &&
                        userBookEpisode?.data?.episode.deleteYn!=='Y' &&

                    <div className="controls my">
                            <Link className="btn _sm _blue" to={`/${school}/userbook/episode/edit/${userBookEpisode?.data?.bookId}/${episode}`}>수정</Link>
                            <button className="btn _sm _red" onClick={onDelete}>삭제</button>
                    </div>
                    }

                    { isSuccess && 
                        <CommentList type="USER_BOOK" root={userBookEpisode?.data?.episode} readOnly={userBookEpisode?.data?.episode.deleteYn === "Y"} />
                    }
                    
                </div>
            </div>
        </div>
    );
};